import { Collapse } from "@mui/material";
import { InputCheck } from "controls";
import React, { useEffect } from "react";

const UserAccess = ({ values, setValues }) => {
  useEffect(() => {
    if (!values.id) {
      values.userAccess
        ? setValues((j) => ({
            ...j,
            user: {
              create: true,
              edit: true,
              delete: true,
              ownAccountEdit: true,
              passwordReset: true,
            },
          }))
        : setValues((j) => ({
            ...j,
            user: {
              create: false,
              edit: false,
              delete: false,
              ownAccountEdit: false,
              passwordReset: false,
            },
          }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.userAccess]);

  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    setValues((j) => ({
      ...j,
      user: { ...j.user, [name]: checked },
    }));
  };

  return (
    <Collapse in={values.userAccess || false}>
      <div className="ml-[3px] grid gap-1 mt-[2px] mb-[10px] !uppercase tracking-wider !pl-[10px] border-l-4  border-rounded">
        <InputCheck
          label="Create"
          checked={values.user?.create || false}
          name={"create"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Edit"
          checked={values.user?.edit || false}
          name={"edit"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Delete"
          checked={values.user?.delete || false}
          name={"delete"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Own Account Edit"
          checked={values.user?.ownAccountEdit || false}
          name={"ownAccountEdit"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Password Reset"
          checked={values.user?.passwordReset || false}
          name={"passwordReset"}
          onClick={handleInpChg}
        />
      </div>
    </Collapse>
  );
};

export default UserAccess;
